import firebase_api from '@/firebase/firebase_api'
import Tirage from "@/firebase/tirage2/tirage"
import joueur_fct from "@/firebase/joueur"

const object = {
    data: {
        description: "",
        date: null,
        start: null,
        heure: "14:30",
        joueurs: [],
        parties:[],
        winAt: 13,
        state: "WAITING",
        id: "", 
        options : {
            nbParties : 3,
            nbJoueurs: null,
            nbJoueursParEquipe: null,
            allEquipePlay: true,
            addPartie: null,
            ifNotFound: {
                win: 13,
                lose: 7
            },
            competition: null,
            mode: null, // ALEATOIRE ou FORME
            joueurs: [],
            GG: false //GAGNANT GAGNANT
        }
    },
    async userToInvite(club, tournoi, fct) {
        var tournoiRef = firebase_api.api.getDb("club").collection("tournoi").doc (tournoi.id);
        var tournoiDoc = tournoiRef.get();
        
    },
    verifyDate(club, dateTest, idTournoi, fct) {
        var bool = true;
       
        if (typeof(club.subscription) != "undefined") {
            if (club.subscription.status == "active") {
                var dateStart = club.subscription.period_start.seconds * 1000;
                var dateEnd = club.subscription.period_end.seconds * 1000;
               
                
                var date = new Date(dateTest);
               
                if (date.getTime() > dateStart && date.getTime() < dateEnd)
                    bool = true;
                else
                    bool = false;
                fct(bool);
            }
            // on oublie de faire le test pour savoir si un tournoi a déjà été programmé à cette date
            /*
                firebase_api.api.getDb().collection("club")
                        .doc(club.id)
                        .collection("tournois")
                        .where("date", "==", dateTest)
                        .get().then(tournoiTestDate=>{
                    if  (tournoiTestDate.empty) {
                        //vérifier si la date est dans comprise dans le bonne subscription
                        var date = new Date(dateTest);
                        if (date.getTime() > dateStart && date.getTime() < dateEnd)
                            bool = true;
                        else
                            bool = false;
                    }
                    else if (typeof(idTournoi) != "undefined") {
                        if (tournoiTestDate.docs.length==1) {
                            var date = new Date(dateTest);
                            if (date.getTime() > dateStart && date.getTime() < dateEnd)
                                bool = tournoiTestDate.docs[0].id == idTournoi;
                            else
                                bool = tournoiTestDate.docs[0].id == idTournoi;
                        }
                        else
                            bool = false;
                    }
                    else
                        bool = false;
                    
                        fct(bool);
                })
                */
            else 
                fct(true);
        }
        else
            fct(true);
    },
    async deleteTournoiDemo(club) {
        var tournoiDoc = await firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").where("demo","==",true).get();
        for (var index in tournoiDoc.docs) {
            await tournoiDoc.docs[index].ref.delete();
        }
    },
    deleteJoueur(club, tournoi, joueurTournoi, fct) {
        if (typeof(tournoi.preinscription)!="undefined") {
            var indexJoueurPresinscrit = tournoi.preinscription.indexOf(joueurTournoi.id);
            if (indexJoueurPresinscrit!=-1)
                tournoi.preinscription.splice(indexJoueurPresinscrit, 1);
        }
        var indexJoueur = tournoi.joueurs.findIndex(elt=>elt.id===joueurTournoi.id);
        
        tournoi.joueurs.splice(indexJoueur,1);
       
        this.set(club, tournoi, ()=>{
            
                    fct();
                
          
        })    
    },
    addJoueur (club, tournoi, joueurTournoi, fct) {
       
        tournoi.joueurs.push(joueurTournoi);
        if (tournoi.options.mode == "FORME" && tournoi.state == "INPROGRESS") {
            tournoi.options.joueurs.push(joueurTournoi);
        }
        fct();
        firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois")
                .doc(tournoi.id).update({
                    joueurs: tournoi.joueurs,
                    options: tournoi.options
                })
            .then(()=>{
              
        })
    },
    IsJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    },
    verifyUndefined(noeud) {
        
        if (typeof(noeud)=="undefined") {
            
            return false;
        }
        else if (Array.isArray(noeud)) {
            var bool = true;
            noeud.forEach(val=>{
                bool = this.verifyUndefined(val) && bool;
            })
            return bool;
        }
        else if (typeof(noeud)=="object") {
            var bool = true;
            for (var key in noeud) {
                bool = this.verifyUndefined(noeud[key]) && bool;
            }
            return bool;
        }
        else
            return true;
    },
    setFinish(club, tournoi, classement, fct) {
        tournoi.state = "FINISH";
        tournoi.classement = classement;
        
        this.set(club, JSON.parse(JSON.stringify(tournoi)), ()=>{
           
            fct()
        })
    },
    get(club, tournoi, fct) {
        
        if (tournoi.id!="") {
            firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id).get().then(tournoiDoc=>{
              
                var tournoiData = tournoiDoc.data();
                
                tournoiData.id = tournoiDoc.id;
                fct(tournoiData);
            })            
        }
    },
    set (club, tournoi, fct) {
       
        if (tournoi.id == "") {
            
            firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois")
                .add(tournoi)  
                .then(tournoiAdd=> {
                    tournoiAdd.update({
                        id: tournoiAdd.id 
                    }).then(()=>{
                        tournoi.id = tournoiAdd.id;
                        fct(tournoi);
                    })
                  
                })
        }
        else {
           
            //delete tournoi.classement;
            firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois")
                .doc(tournoi.id).set(tournoi)
                .then(
                    ()=>{
                       
                        fct(tournoi);
                    })
                .catch(err=>{
                    
                    console.log(err)
                })
            
        }
    },
    removeParties(club, tournoi, fct) {
        firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id)
                .collection("parties").get().then(partiesDocs=>{
                    if (partiesDocs.docs.length==0)
                        fct();
                    else {
                        for (var indexPartie in partiesDocs.docs) {
                            partiesDocs.docs[indexPartie].ref.delete();
                            if (indexPartie == partiesDocs.docs.length-1)
                                fct()
                        }
                    }
                })
    },
    removeEquipeParties(club, tournoi, indexPartie, nbParties, fct) {
        firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id)
                .collection("parties").doc("P"+indexPartie.toString()).collection("equipes")
                .get().then(equipeDocs=> {
                  
                    for (var indexEquipe in equipeDocs.docs) {
                        equipeDocs.docs[indexEquipe].ref.delete();
                        if (indexEquipe == equipeDocs.docs.length-1) {
                            if (indexPartie == nbParties-1)
                                fct();
                            else
                                this.removeEquipeParties(club, tournoi, indexPartie+1, nbParties, fct);
                                
                        }
                    }
                    if (equipeDocs.empty==0)
                        fct();
                });
    },
    initEquipe (club, tournoi, indexPartie, equipes, fct) {
        
        for (var indexEquipe in equipes) {    
            var equipe = equipes[indexEquipe];
            
            firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id)
                .collection("parties").doc("P"+indexPartie.toString()).collection("equipes").doc("E"+indexEquipe.toString()).set(
                    equipe
            )
            if (indexEquipe == equipes.length-1) 
                fct();
        }
        if (equipes.length==0)
            fct();
    },
    async isTournoiDemo(club) {
        var tournoiDoc = await firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").where("demo","==",true).get();
        return !tournoiDoc.empty;
    },
    initEquipeForme(tournoi) {
        var joueursFormWorking = [];
        
        var joueursFormeOrigine = tournoi.joueurs
        joueursFormeOrigine.forEach(joueur=>{
            if (joueur.meneur)
                joueursFormWorking.push(JSON.parse(JSON.stringify(joueur)));
        })
        joueursFormeOrigine.forEach(joueur=>{
            if (!joueur.meneur)
                joueursFormWorking.push(JSON.parse(JSON.stringify(joueur)));
        })
        joueursFormWorking.forEach((joueur, indexJoueur)=>{
            tournoi.joueurs[indexJoueur] = JSON.parse(JSON.stringify(joueur));
            if (joueur.coequipier1) {
              
                var indexJoueur1 = joueursFormWorking.findIndex(joueurFind=>joueurFind.id===joueur.coequipier1);
               
                joueur.coequipier1 = indexJoueur1;
                
            }
            if (joueur.coequipier2) {
                var indexJoueur2 = joueursFormWorking.findIndex(joueurFind=>joueurFind.id===joueur.coequipier2);
                joueur.coequipier2 = indexJoueur2;
               
            }
            
        })
        return joueursFormWorking;
    },
    async affectJoueursSaison (club, tournoi, fct) {
        
        
        if (tournoi.state == 'INPROGRESS' || tournoi.state == 'FINISH') {
            var saisonDb = await firebase_api.api.getDb().collection("club").doc(club.id)
                        .collection("saisons").doc(tournoi.saison)
            var saisonDoc = await saisonDb.get()
            var saisonData = saisonDoc.data();
            if (saisonData.tournois.indexOf(tournoi.id)==-1) {
                saisonData.tournois.push(tournoi.id);
            }
            tournoi.joueurs.forEach(joueur=>{
                var index = saisonData.joueurs.findIndex(elt=>elt.id === joueur.id)
                if (index==-1) {
                    var item = {
                        id: joueur.id,
                        nb: 1
                    }
                    saisonData.joueurs.push(item);
                }
                else {
                    saisonData.joueurs[index].nb ++;
                }
            })
            await saisonDb.update({
                joueurs: saisonData.joueurs,
                tournois: saisonData.tournois
            })
        }
        
       
        fct();
    },
    async deaffectJoueursSaison (club, tournoi, fct) {
        if (tournoi.state != "INSCRIPTION") {
            var saisonDb = await firebase_api.api.getDb().collection("club").doc(club.id)
                            .collection("saisons").doc(tournoi.saison)
            var saisonDoc = await saisonDb.get()
            var saisonData = saisonDoc.data();
            if (saisonData.tournois.indexOf(tournoi.id)!=-1) {
                saisonData.tournois.splice(saisonData.tournois.indexOf(tournoi.id), 1);
            }
            tournoi.joueurs.forEach(joueur=>{
                var index = saisonData.joueurs.findIndex(elt=>elt.id === joueur.id)
                if (index!=-1) {
                    var item = saisonData.joueurs[index];
                    item.nb --;
                    if (item.nb==0)
                        saisonData.joueurs.splice(index, 1)
                    else
                        saisonData.joueurs[index] = item;
                }
            })
            await saisonDb.update({
                joueurs: saisonData.joueurs,
                tournois: saisonData.tournois
            })
        }
        fct();
    },
    async addJoueursBySeason (club, tournoi) {
        if (tournoi.joueurs.length==0 && tournoi.state!="INPROGRESS") {
            
            if (typeof(tournoi.saison)!="undefined") {
                if (tournoi.saison!=null) {
                    var clubDb = firebase_api.api.getDb().collection("club").doc(club.id)
                    var clubJoueursDocs = await clubDb.collection("joueurs").get();
                    var listJoueurs = [];
                   
                    clubJoueursDocs.docs.forEach(joueurItemDoc=>{
                        listJoueurs.push(joueurItemDoc.data());
                    })
                  
                    var saisonDb = clubDb.collection("saisons").doc(tournoi.saison);
                    var saisonDoc = await saisonDb.get();
                    var saisonData = saisonDoc.data();
                    saisonData.joueurs.forEach(joueurSaisonItem=>{
                        var joueurClub = listJoueurs.find(elt=>elt.id === joueurSaisonItem.id);
                        if (typeof(joueurClub)!="undefined") {
                            var joueurTournoi = JSON.parse(JSON.stringify(joueur_fct.object.tournoi));
                            joueurTournoi.id = joueurClub.id;
                            joueurTournoi.pseudo = joueurClub.pseudo;
                            joueurTournoi.nom = joueurClub.nom;
                            joueurTournoi.prenom = joueurClub.prenom;
                            if (typeof(joueurClub.elo) == "undefined")
                                joueurTournoi.elo = 1199;
                            else
                                joueurTournoi.elo = parseFloat(joueurClub.elo);
                            tournoi.joueurs.push(joueurTournoi);
                        }
                    })
                    
                    await firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois")
                    .doc(tournoi.id)    
                    .update({
                        joueurs: tournoi.joueurs
                    })
                    
                }
            }
        }
    },
    async setState(club, tournoi, state, fct) {
      
        var start = new Date();
        var heure = start.getHours() + ':' + start.getMinutes();
        var options = JSON.parse(JSON.stringify(tournoi.options));
        
        /*
        var workDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());
        tournoi.date = workDate.getTime();
        
        tournoi.heure = heure;
        */
        tournoi.options = options;
     
        if (state == "INPROGRESS") {
            tournoi.state = state;
            tournoi.start = start.getTime();
            // Alors on effectue le tirage et on sauvegarde les parties
            // var parties = tirage.fct.executeTirage(tournoi);
            
            // Si le tournoi appartient à une saison
            if (typeof(tournoi.saison)!="undefined")
                if (tournoi.saison!=null) {
                    this.affectJoueursSaison (club, tournoi, ()=>{});
                }
          
            options.nbJoueurs = tournoi.joueurs.length;
            if (tournoi.options.mode == "FORME") {
                options.joueurs = this.initEquipeForme(tournoi);
            }
        
            var optionsave = JSON.parse(JSON.stringify(options));
            var tirage_inst = new Tirage (options);
            
            var error = tirage_inst.init();
            tournoi.options = JSON.parse(JSON.stringify(optionsave));
            var parties;
            if (!error) {
                parties = tirage_inst.partiesJSON;
                
           }
           else {
              
                var jsonParties = await tirage_inst.findModeleJSON(tirage_inst.nbError);
             
                
                if (jsonParties.find && !options.addPartie) {
                    parties = jsonParties.jsonData;
                    
                }
                else {
                    
                    parties = tirage_inst.partiesJSON;
                } 
           }
        
           
            for (var indexPartie in parties) {
                var partie = parties[indexPartie]
                var partieData = {
                    index : indexPartie,
                    state : "WAITING",
                    complementaire: partie.complementaire,
                    error: partie.error,
                    nbError: partie.nbError
                };
                
                // j'ai enlevé le await
                
                firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id)
                    .collection("parties").doc("P"+indexPartie.toString()).set(
                        partieData
                    )
                
                this.initEquipe (club, tournoi, indexPartie, partie.equipes, ()=>{});
                   
                

                if (indexPartie == parties.length-1) {
                 
                    tournoi.state = state;
                    this.set(club, tournoi, ()=>{})   
                    fct(tournoi);
                }
            // TEST 
    
            // j'enlève le await pour le mode hors connection : va va être la merde
            /*
            for (var indexPartie in parties) {
                var partie = parties[indexPartie]
                await this.initEquipe (club, tournoi, indexPartie, partie.equipes, ()=>{});
            }*/
         
            }
        }
        else if (state == "INSCRIPTION") {
          
            this.addJoueursBySeason(club, tournoi);
            if (typeof(tournoi.options.zones)!="undefined") {
                for (var zone in tournoi.options.zones) {
                    for (var terrain in tournoi.options.zones[zone].terrains) {
                        tournoi.options.zones[zone].terrains[terrain].parties = [];
                    }
                }
            }
            if (tournoi.state == "INPROGRESS") {
                delete tournoi.cadrage;
                delete tournoi.pools;
                delete tournoi.options.resultatPoule;
                tournoi.joueurs.forEach((joueur, index)=>{
                    if (!joueur.inscriptionValide) {
                        delete tournoi.joueurs.splice(index);
                    }
                })
                this.removeParties(club, tournoi, ()=>{
                    tournoi.state = state;
                    this.set(club, tournoi, ()=>{
                        
                    })
                    fct(tournoi);
                })
            }
        }
    },
    calculElo (equipe, vs, win, joueurs) {
        var eloMyequipeWIN = 0;
        var nbJoueurWin = 0;

        var vsWIN, vsLose;

        if (win) {
            vsWIN = vs;
            vsLose = vs == "joueurs" ? "contre" : "joueurs"
        }
        else {
            vsLose = vs;
            vsWIN = vs == "joueurs" ? "contre" : "joueurs"
        }
            

        for (var idJoueurElo in equipe[vsWIN]) {
            if (equipe[vsWIN][idJoueurElo] != null) {
                eloMyequipeWIN += joueurs[equipe[vsWIN][idJoueurElo].numero].elo;
                nbJoueurWin++;
            }
        }
        if (nbJoueurWin>0)
            eloMyequipeWIN = eloMyequipeWIN / nbJoueurWin;
        
        var eloMyequipeLose = 0;
        var nbJoueurLose = 0;                            
        

        for (var idJoueurElo in equipe[vsLose]) {
            if (equipe[vsLose][idJoueurElo] != null) {
                if (typeof(joueurs[equipe[vsLose][idJoueurElo].numero])!="undefined")
                    eloMyequipeLose += joueurs[equipe[vsLose][idJoueurElo].numero].elo;
                nbJoueurLose++;
            }
        }
        if (nbJoueurLose>0)
            eloMyequipeLose = eloMyequipeLose / nbJoueurLose;
        var elo = {
            win: eloMyequipeWIN,
            lose: eloMyequipeLose
        }
        return elo;
    },
    getNameJoueurForResult (joueur) {
        var displayName = "";
        var boolFind = false;
        if (typeof(joueur) != "undefined") {
          
            if (joueur.nom != '') {
                displayName = joueur.nom;
                boolFind = true;
            }
            if (joueur.prenom != '') {
                displayName = displayName + " " + joueur.prenom;
                boolFind = true;
            }
            if (!boolFind)
                displayName = joueur.pseudo;
            return displayName;
        }
        else    
            return "";
    },
    returnInstanceResultat(diff, equipe, vs, gagne, indexPartie, tableauResultat, tournoi, equipeVS) {
        var contenuTableau = {
            numero: null,
            score: 0,
            nbPartieGagne: 0,
            nbPartiePerdu: 0,
            nbPartieEgalite: 0,
            diff: 0,
            partieScore: [],
            parties:{},
            nbPartieJoues: 0,
            captain: "",
            captainId: null,
            coequipier1: "",
            coequipier2: ""
        }
     
        for (var idJoueur in equipe[vs]) {
            if (equipe[vs][idJoueur] != null) {
                var numero = equipe[vs][idJoueur].numero;
                var joueur =  tournoi.joueurs[numero];
                var meneur = joueur.meneur;
                if (tournoi.options.mode=="ALEA" || meneur) {
                    if (typeof(tableauResultat[numero]) == "undefined") {
                        tableauResultat[numero] = JSON.parse(JSON.stringify(contenuTableau));
                    }
                    tableauResultat[numero].numero = numero;
                    tableauResultat[numero].nbPartieJoues ++;
                   
                    if (diff==0) {
                        tableauResultat[numero].nbPartieEgalite ++;
                        tableauResultat[numero].partieScore[indexPartie] = 0;
                    }
                    else if (gagne) {
                        tableauResultat[numero].partieScore[indexPartie] = diff;
                        tableauResultat[numero].nbPartieGagne ++;
                        tableauResultat[numero].diff += diff;   
                    }
                    else {
                        tableauResultat[numero].partieScore[indexPartie] = -diff;
                        tableauResultat[numero].nbPartiePerdu ++;
                        tableauResultat[numero].diff -= diff;
                    }
                    tableauResultat[numero].score = tableauResultat[numero].nbPartieGagne;
                    if (typeof(tableauResultat[numero].elo) == "undefined")
                                tableauResultat[numero].elo = [];
                    tableauResultat[numero].elo[indexPartie] = this.calculElo(equipe, vs, true, tournoi.joueurs);
                    tableauResultat[numero].captain = this.getNameJoueurForResult(joueur);
                    tableauResultat[numero].captainId = joueur.id;
                    if (tournoi.options.mode=="FORME") {
                        tableauResultat[numero].nameEquipe = tableauResultat[numero].captain;
                        if (typeof(joueur.nameEquipe)!="undefined")
                            if (joueur.nameEquipe!="")
                                tableauResultat[numero].nameEquipe = joueur.nameEquipe;
                        
                        var coequipier1Numero = joueur.coequipier1;
                        var coequipier2Numero = joueur.coequipier2;
                        if (coequipier1Numero != null) {
                            var joueurCoequipier1 = tournoi.joueurs.find(joueurTempo=>joueurTempo.id === coequipier1Numero);
                            tableauResultat[numero].coequipier1 = this.getNameJoueurForResult(joueurCoequipier1);
                        }
                        if (coequipier2Numero != null) {
                            var joueurCoequipier2 = tournoi.joueurs.find(joueurTempo=>joueurTempo.id === coequipier2Numero);
                            tableauResultat[numero].coequipier2 = this.getNameJoueurForResult(joueurCoequipier2);
                        }
                    }
                }
            }
        }
        return tableauResultat;
    },
    notResultat(tournoi, equipe) {
        
        if (tournoi.options.addPartie != null && tournoi.options.addPartie) {
            
            // ca veut dire qu'on est sur une équipe où il y a des joueurs qui ne jouent pas de suite
            return (equipe.contre.J1 != null)
        }   
        else 
            return true;
    },
    resultatTournoi(parties, tournoi) {
        var tableauResultat = [];
      
        parties.forEach((partie, indexPartie) => {
         
            partie.equipes.forEach((equipe, indiceEquipe)=>{
                   
                    if (equipe.state == "FINISH" && this.notResultat(tournoi,equipe)) {
                      
                        var diff = Math.abs(parseInt(equipe.score["joueurs"]) -  parseInt(equipe.score["contre"]));
                        if (parseInt(equipe.score["joueurs"]) >= parseInt(equipe.score["contre"])) {
                            var egalite = !(diff == 0);
                            tableauResultat = this.returnInstanceResultat(diff, equipe, "joueurs", egalite, indexPartie, tableauResultat, tournoi)
                            tableauResultat = this.returnInstanceResultat(diff , equipe, "contre", false, indexPartie, tableauResultat, tournoi)
                        }
                        else {
                            tableauResultat = this.returnInstanceResultat(diff, equipe,"contre", true, indexPartie, tableauResultat, tournoi)
                            tableauResultat = this.returnInstanceResultat(diff, equipe,"joueurs", false, indexPartie, tableauResultat, tournoi)                       
                        }
                    }
                    else {
                        var contenuTableau = {
                            numero: null,
                            score: 0,
                            nbPartieGagne: 0,
                            nbPartiePerdu: 0,
                            diff: 0,
                            partieScore: [],
                            parties:{},
                            nbPartieJoues: 0
                        }
                       
                        for (var vsEquipe in equipe) {
                            if (vsEquipe == 'joueurs' || vsEquipe == 'contre') {
                                for (var idJoueur in equipe[vsEquipe]) {
                                    if (equipe[vsEquipe][idJoueur] != null) {
                                    
                                        var numero = equipe[vsEquipe][idJoueur].numero;
                                    
                                        if (tournoi.options.mode == 'ALEA' || tournoi.joueurs[numero].meneur) {
                                            var joueur = tournoi.joueurs[numero];
                                            if (typeof(tableauResultat[numero]) == "undefined") {
                                                tableauResultat[numero] = JSON.parse(JSON.stringify(contenuTableau));
                                            }
                                            tableauResultat[numero].numero = numero;
                                            tableauResultat[numero].captain = this.getNameJoueurForResult(joueur);
                                            tableauResultat[numero].inscriptionValide = joueur.inscriptionValide;
                                            tableauResultat[numero].captainId = joueur.id;
                                            if (tournoi.options.mode=="FORME") {
                                                tableauResultat[numero].numero = numero;
                                                tableauResultat[numero].nameEquipe = tableauResultat[numero].captain;
                                                if (typeof(joueur.nameEquipe)!="undefined")
                                                    if (joueur.nameEquipe!="")
                                                        tableauResultat[numero].nameEquipe = joueur.nameEquipe;
                                                
                                                var coequipier1Numero = joueur.coequipier1;
                                                var coequipier2Numero = joueur.coequipier2;
                                              
                                                if (coequipier1Numero != null) {
                                                    var joueurCoequipier1 = tournoi.joueurs.find(joueurTempo=>joueurTempo.id === coequipier1Numero);
                                                    tableauResultat[numero].coequipier1 = this.getNameJoueurForResult(joueurCoequipier1);
                                                }
                                                if (coequipier2Numero != null) {
                                                    var joueurCoequipier2 = tournoi.joueurs.find(joueurTempo=>joueurTempo.id === coequipier2Numero);
                                                    tableauResultat[numero].coequipier2 = this.getNameJoueurForResult(joueurCoequipier2);
                                                }
                                            }
                                        }
                                        
                                    }
                                }
                            }
                        }
                    }

            })
         
        });
       
        tableauResultat.forEach(item=>{
            if (typeof(item.elo) != "undefined") {
                item.elo.forEach(eloItem=>{
                    if (eloItem==null) 
                        eloItem = {};
                });
            }
            item.partieScore.forEach(partieItem=>{
                if (partieItem == null)
                    partieItem = 0;
            })
        })
      
        return tableauResultat;
    },
    getTournoiInprocess (tournoi, fct) {
        var tournoi = tournoi.tournoiInProgress;
        tournoi.get().then(doc=>{
            var docData = doc.data();
            docData.id = doc.id;
            fct(docData)
        });
    },
    saveTournoi (club, tournoi, fct) {
        firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois")
            .doc(tournoi.id).set(tournoi)
            .then(()=>{
                fct()
            })
            .catch(error=>{

            })
    },
    delete (club, idTournoi, fct) {
        firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(idTournoi).delete()
            .then(()=>{
                fct();
            })
    },
    async addPartie(club, tournoi, parties, gg, fct) {
       
        var tirage_inst = new Tirage(tournoi.options, parties);
      
        if (gg)
            var indexPartie = tirage_inst.addPartieGG();
        else    
            var indexPartie = tirage_inst.addPartie();
        
        var partieTempo = tirage_inst.partiesJSON[indexPartie];
        var partieData = {
            index : indexPartie,
            state : "WAITING",
            complementaire: partieTempo.complementaire,
            error: partieTempo.error,
            nbError: partieTempo.nbError,
            id: "P"+indexPartie.toString()
        };
      
        firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id)
            .collection("parties").doc(partieData.id).set(
                partieData
            )
            .then(async ()=>{
              
            }) 
            .catch(async (error)=>{
                
                console.log(error);
            })
           
        this.initEquipe (club, tournoi, indexPartie, partieTempo.equipes, fct)
      
        
    },
    async reinitTournoi(club, tournoi, parties, indexPartie, fct) {
    
       // var parties  = tirage.fct.executeTirage(tournoi, parties, indexPartie);
        /*tournoi.tournoiInProgress.update({
            parties: parties
        })
        .then(()=>{
            fct(JSON.parse(JSON.stringify(parties)));
        })*/
        var nbIteration = 0;
        var partieSave = null;
        
        var nbError = Number.MAX_VALUE;
        while (nbIteration < 100) {
            var tirage_inst = new Tirage(tournoi.options, parties);
          
            var error = tirage_inst.reinit(indexPartie);
            if (tirage_inst.nbError < nbError) {
                nbError = tirage_inst.nbError;
                partieSave = JSON.parse(JSON.stringify(tirage_inst.partiesJSON));
                
            }
            if (!error)
                break;
            nbIteration++;
        }
        parties = JSON.parse(JSON.stringify(partieSave));
        
      
        var startIndexPartie = indexPartie;
        this.removeEquipeParties(club, tournoi, startIndexPartie, parties.length, ()=>{
                
                for (var startIndexPartie2=indexPartie;startIndexPartie2<parties.length;startIndexPartie2++) {
                    this.initEquipe(club, tournoi, startIndexPartie2, parties[startIndexPartie2].equipes, ()=>{
                    });
                    firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").
                    doc(tournoi.id).collection("parties").doc("P"+startIndexPartie2).
                    update({
                        error: parties[startIndexPartie2].error
                    })
                }
                fct();
        });
        
    },
    setTournoi(club, tournoi, fct) {
        var tournoiInProgress = {
            parties: [],
            winPoint: tournoi.winPoint,
            losePoint: tournoi.losePoint,
            winAt: tournoi.winAt
        }
        tournoiInProgress.parties = tirage.fct.executeTirage(tournoi);
        firebase_api.api.getDb().collection("club").doc(club.id).collection("tournoi").add(tournoiInProgress)
            .then(addData=>{
                tournoiInProgress.id = addData.id; 
                club.tournois[tournoi.id].tournoiInProgress = addData;
                firebase_api.api.getDb().collection("club").doc(club.id).update(club)
                    .then(()=>{
                    
                })
                fct(tournoiInProgress);
            })

    },
    addEquipeGGnotAll(club, tournoi, indexPartie, equipe) {
      
        // on regarde si il existe la partie d'après a été initialisé
        var tournoiDoc = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
        var partieDocs = tournoiDoc.collection("parties");
        
        var partieDoc = partieDocs.doc("P" + (indexPartie + 1));
      
        partieDoc.get().then(query=>{
          
            if (!query.exists) {
                var partieData = {
                    complementaire: false,
                    error: false,
                    index: indexPartie+1,
                    nbError: 0,
                    state: "WAITING"
                }
            
                partieData.equipes = [];
                partieDoc.set( partieData).then(()=>{
                    
                })
                this.subAddEquipeGGnotAll(club, tournoi, indexPartie, equipe)
            }
            else {
                this.subAddEquipeGGnotAll(club, tournoi, indexPartie, equipe)
            }
        });
            
        },
        subAddEquipeGGnotAll(club, tournoi, indexPartie, equipe) {
            
            var tournoiDoc = firebase_api.api.getDb().collection("club").doc(club.id).collection("tournois").doc(tournoi.id);
            var partieDocs = tournoiDoc.collection("parties");
            
            var partiesData = [];
            partieDocs.get().then(partiesRef =>{
                partiesRef.docs.forEach((partieRef, indexPartieRef)=>{
                    var partieData = partieRef.data();
                    partieData.id = partieRef.id;
                    partieData.equipes = [];
                    partiesData.push(partieData);
                    partieRef.ref.collection("equipes").get().then(snapshot=>{
                        if (snapshot.docs.length==0)
                            this.addOneEquipeGGnotAll(club, tournoi, indexPartie, partiesData, equipe)
                        else {
                            snapshot.docs.forEach((doc, indiceEquipe)=>{
                                var docData = doc.data();
                                delete docData[".key"]
                                partiesData[indexPartieRef].equipes.push(docData);
                                if (indiceEquipe == snapshot.docs.length-1 && indexPartieRef==partiesRef.docs.length-1) 
                                    this.addOneEquipeGGnotAll(club, tournoi, indexPartie, partiesData, equipe)
                            })
                        }
                    })
                });
        })
    },
    addOneEquipeGGnotAll(club, tournoi, indexPartie, partiesData, equipe) {
        
      
        
        if (!tournoi.options.allEquipePlay) {
          
            var tirage_inst = new Tirage(tournoi.options, partiesData); 
            var partieJson = tirage_inst.addOneEquipeGG(indexPartie, equipe);
            this.initEquipe (club, tournoi, indexPartie+1, partieJson.equipes, ()=>{  });
        }
       else if (typeof(tournoi.options.choiceWaitingPartie)!="undefined" && 
                !tournoi.options.choiceWaitingPartie) {
           
            var tirage_inst = new Tirage(tournoi.options, partiesData); 
            var partieJson = tirage_inst.addOneEquipeGGAllPlay(indexPartie, equipe);
            if (partieJson!=null) {
                this.initEquipe (club, tournoi, indexPartie+1, partieJson.equipes, ()=>{  });
            }
       }
           
      
    },

    setTournoiGG(club, tournoi, indexPartie, equipe) {
     
        if (tournoi.options.GG) {
            if (tournoi.options.mode=="ALEA" && 
                typeof(tournoi.options.choiceWaitingPartie)!="undefined" && 
                !tournoi.options.choiceWaitingPartie)
                    this.addEquipeGGnotAll(club, tournoi, indexPartie, equipe);
            else if (tournoi.options.mode=="FORME")
                this.addEquipeGGnotAll(club, tournoi, indexPartie, equipe);
            else if (tournoi.options.mode=="ALEA" && tournoi.options.nbJoueursParEquipe==1)
                this.addEquipeGGnotAll(club, tournoi, indexPartie, equipe);
            else if (!tournoi.options.allEquipePlay) {
               
                this.addEquipeGGnotAll(club, tournoi, indexPartie, equipe);
            }
        }
    },

    async copyToDebug(clubId, tournoiItem) {
        var tournoiItemCopy = JSON.parse(JSON.stringify(tournoiItem));
        var tournoiAddDebug =  await firebase_api.api.getDb().collection("club").doc("debug").collection("tournois").add(tournoiItemCopy);
        console.log(tournoiAddDebug);
        var tournoiAddDebugRef = firebase_api.api.getDb().collection("club").doc("debug").collection("tournois").doc(tournoiAddDebug.id);
        var clubOrigine = await firebase_api.api.getDb().collection("club").doc(clubId);
        var tournoiRef = clubOrigine.collection("tournois").doc(tournoiItem.id);
        var partiesRef = await tournoiRef.collection("parties").get();
        console.log(partiesRef.docs);
        var partiesDatas=[];
        for (var indexPartie in partiesRef.docs) {
            console.log(indexPartie);
            var partie = partiesRef.docs[indexPartie];
            var equipesRef = await partie.ref.collection("equipes").get();
            var partieData = partie.data();
            await tournoiAddDebugRef.collection("parties").doc(partie.id).set(partieData);
            for (var indexEquipe in equipesRef.docs) {
                var equipe = equipesRef.docs[indexEquipe];
                await tournoiAddDebugRef.collection("parties").doc(partie.id).collection("equipes")
                    .doc(equipe.id).set(equipe.data());
            }
        }
    }

        
}
    


export default {
    object: object
}